import React, { useState, useEffect } from 'react'
import {
    Toolbar,
    Button,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@material-ui/core'
import { useGlobalStyles } from '../../../../App'
import rolePermissionGroupService from '../../../../services/rolePermissionGroup.service'
import TableContentLoadingSpinner from '../../../shared/TableContentLoadingSpinner'

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        padding: theme.spacing(2),
    },
    enhancedTableToolbar: {
        width: '100%',

        '& .MuiToolbar-gutters': {
            paddingRight: 16,
        },
    },
    toolBar: {
        float: 'right',
    },
    tableSection: {
        marginTop: 25,
    },
    formControl: {
        minWidth: 120,
        maxWidth: 300,
    },
    toolbarButtons: {
        marginLeft: 'auto',
    },
}))

const headCells = [
    { id: 'firstName', label: 'First Name' },
    { id: 'preferredFirstName', label: 'Preferred First Name' },
    { id: 'surname', label: 'Surname' },
    { id: 'employeeId', label: 'Employee Id' },
]

const Members = ({ rolePermissionGroupId }) => {
    const classes = useStyles()
    const globalClasses = useGlobalStyles()
    const [tableData, setTableData] = useState()
    const [isLoadingData, setIsLoadingData] = useState(true)

    const updateTableData = async () => {
        try {
            setIsLoadingData(true)
            await rolePermissionGroupService
                .getAllGroupMembers(rolePermissionGroupId)
                .then(result => {
                    setTableData(result)
                })
        } catch (exception) {
            console.log(exception)
        } finally {
            setIsLoadingData(false)
        }
    }

    useEffect(() => {
        ;(async function updatePageTableDataAsync() {
            try {
                updateTableData()
            } catch (exception) {
                console.log(exception)
            }
        })()
    }, [])

    const EnhancedTableToolbar = () => {
        return (
            <div className={classes.enhancedTableToolbar}>
                <Toolbar>
                    <Button
                        className={classes.toolbarButtons}
                        data-testid='add-button'
                        variant='contained'
                        color='secondary'>
                        Add
                    </Button>
                </Toolbar>
            </div>
        )
    }

    const getTableContent = () => {
        if (isLoadingData) {
            return <TableContentLoadingSpinner />
        }

        return tableData.map(row => (
            <TableRow>
                <TableCell>{row.firstName}</TableCell>
                <TableCell>{row.preferredFirstName}</TableCell>
                <TableCell>{row.surname}</TableCell>
                <TableCell>{row.employeeId}</TableCell>
                <TableCell align='right'>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={() => {}}>
                        Remove
                    </Button>
                </TableCell>
            </TableRow>
        ))
    }

    return (
        <Paper className={classes.tableWrapper}>
            <div className={classes.tableSection}>
                <EnhancedTableToolbar />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby='tableTitle'
                        aria-label='enhanced table'>
                        <TableHead className={globalClasses.tableHeader}>
                            <TableRow>
                                {headCells.map((headCell, index) => (
                                    <TableCell key={'head-cell-' + index}>
                                        {headCell.label}
                                    </TableCell>
                                ))}
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>{getTableContent()}</TableBody>
                    </Table>
                </TableContainer>
            </div>
        </Paper>
    )
}

export default Members
